import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import api from "@/lib/api";
import AIContentBlock from "@/components/AIContentBlock";

export default function Instruments() {
  const [instruments, setInstruments] = useState([]);

  useEffect(() => {
    api.get("/instruments").then((r) => setInstruments(r.data)).catch(console.error);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="instruments-page">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-slate-500 mb-3">Instruments &amp; Music Technology</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-slate-900">Tools of <span className="gradient-text">Tradition.</span></h1>
      <p className="mt-3 text-slate-600 max-w-2xl">Construction, technique, makers and masters — a directory of the instruments that give every place its voice.</p>

      <AIContentBlock pageKey="instruments" topic="Musical instruments of the world and the craft of making them" imgQuery="traditional musical instruments workshop" />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10">
        {instruments.map((i) => (
          <Link key={i.slug} to={`/instruments/${i.slug}`} data-testid={`instrument-card-${i.slug}`} className="card-lift bg-white rounded-3xl border border-slate-100 overflow-hidden group">
            <div className="h-40 overflow-hidden">
              <img src={i.image} alt={i.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-4">
              <h2 className="font-bold text-slate-900">{i.name}</h2>
              <p className="text-[11px] font-bold uppercase tracking-wide text-purple-600 mt-0.5">{i.classification}</p>
              <p className="text-xs text-slate-500 flex items-center gap-1 mt-2"><MapPin className="w-3 h-3 text-pink-500" /> {i.origin}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
